/**
 * 盤面の「仕込み中」の幕（index.html の .stage-loader）を動かす。
 *
 * 幕そのものは HTML に直接書いてあり、JS が届く前から見えている。
 * ここでは進み具合のバーと、ひとことの差し替えと、消す合図だけを受け持つ。
 */

const TIPS = [
  '同じ料理どうしがぶつかると、ひとつ上の料理になります',
  '大きい料理は端に寄せておくと、真ん中が広く使えます',
  '背景のきらめきをタップすると、その土地の豆知識が読めます',
  '図鑑の「？」は、その料理がはじめて出てくると開きます',
  '器の口より高く積んでも、こぼさなければセーフ',
  'のんびりモードなら、こぼれても終わりません',
];

const TIP_INTERVAL_MS = 2600;

export class StageLoader {
  private readonly root: HTMLElement | null;
  private readonly fill: HTMLElement | null;
  private readonly tip: HTMLElement | null;
  private progress = 0;
  private tipIndex = 0;
  private timer: number | undefined;
  private done = false;

  constructor(doc: Document = document) {
    this.root = doc.querySelector<HTMLElement>('[data-ui="stage-loader"]');
    this.fill = doc.querySelector<HTMLElement>('[data-ui="loader-fill"]');
    this.tip = doc.querySelector<HTMLElement>('[data-ui="loader-tip"]');
    if (!this.root) return;
    this.set(0.08);
    this.timer = window.setInterval(() => this.nextTip(), TIP_INTERVAL_MS);
  }

  /** 0〜1。戻る方向には動かさない（バーが後ずさりすると不安に見える）。 */
  set(value: number): void {
    if (this.done || !this.fill) return;
    const clamped = Math.min(1, Math.max(0, value));
    if (clamped <= this.progress) return;
    this.progress = clamped;
    this.fill.style.width = `${Math.round(clamped * 100)}%`;
  }

  /** 盤面が描かれてから、ふわっと消す。 */
  finish(): void {
    if (this.done || !this.root) return;
    this.set(1);
    this.done = true;
    window.clearInterval(this.timer);
    const root = this.root;
    // 背景シーンが最初の1枚を描くまで待ってから消す（黒い一瞬を見せない）
    requestAnimationFrame(() =>
      requestAnimationFrame(() => {
        window.setTimeout(() => {
          root.dataset.state = 'done';
          root.setAttribute('aria-busy', 'false');
        }, 180);
      }),
    );
  }

  private nextTip(): void {
    const tip = this.tip;
    if (!tip) return;
    tip.dataset.fading = 'true';
    window.setTimeout(() => {
      this.tipIndex = (this.tipIndex + 1) % TIPS.length;
      tip.textContent = TIPS[this.tipIndex] ?? '';
      tip.dataset.fading = 'false';
    }, 300);
  }
}
